import { Control, Controller } from 'react-hook-form';

import LoginModuleWrapper from '../../components/LoginModuleWrapper';
import { OtpLoginI } from '../../utils/interface';
import styles from './OtpLogin.module.scss';

interface OtpLoginContainerI {
  control: Control<OtpLoginI>;
  isApiLoading?: boolean;
  handleKeyDown: (e: any, i: number) => void;
  handleChange: (e: any, i: number) => void;
  qrCode?: string;
  logoUrl?: string;
}

const OtpLoginContainer = ({ control, isApiLoading, handleKeyDown, handleChange, qrCode, logoUrl }: OtpLoginContainerI) => {

  return (
    <LoginModuleWrapper logoUrl={logoUrl}>
      <div className={styles.formContainer}>
        <p className={styles.heading}>Multi-Factor Authentication</p>
        {qrCode && (
          <>
            <p className={styles.subHeading}>Scan the QR code on your authenticator app</p>
            <img className={styles.qrCode} src={qrCode} alt='qrCode' />
          </>
        )}
        <p className={styles.subHeading}>Please enter the 6-digit verification code.</p>
        <div className={styles.form}>
          {Array.from({ length: 6 }).map((_, index) => (
            <Controller
              key={index}
              name={`digits.${index}`}
              control={control}
              render={({ field }) => (
                <input
                  {...field}
                  type='text'
                  maxLength={1}
                  id={`digit-${index}`}
                  autoComplete='off'
                  onChange={e => handleChange(e, index)}
                  onKeyDown={e => handleKeyDown(e, index)}
                  disabled={isApiLoading}
                  autoFocus={index === 0}
                />
              )}
            />
          ))}
        </div>
      </div>
    </LoginModuleWrapper>
  );
};

export default OtpLoginContainer;
